module.exports = __webpack_public_path__ + "static/media/-7ca6-452b-ac44-30540d1f41a9.ac9c917.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/-7ca6-452b-ac44-30540d1f41a9.mp4
// module id = HlP4
// module chunks = 8